export default __webpack_public_path__ + "static/media/CV_ENGLISH.1f7042fd.pdf";